var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "65.000000pt",
    height: "61.000000pt",
    viewBox: "0 0 65.000000 61.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,61.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468 523 l-47 -48 -116 3 -116 3 -11 29 c-19 56 -82 47 -93 -13 -4 -18 -5 -108 -3 -200 2 -136 6 -170 18 -177 8 -5 123 -10 258 -10 l242 0 0 185 0 185 -34 0 c-19 0 -38 -4 -41 -10 -4 -6 5 -10 19 -10 l26 0 0 -165 0 -165 -195 0 -195 0 0 164 0 165 115 3 c63 2 115 1 115 -2 0 -3 -20 -25 -44 -49 -40 -39 -65 -86 -53 -98 14 -14 84 37 167 121 80 81 93 99 84 114 -20 32 -47 25 -96 -25z m72 7 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-380 -176 l0 -154 -25 0 -25 0 0 159 c0 118 3 160 13 164 31 11 37 -14 37 -169z m294 85 c-32 -32 -65 -59 -73 -59 -9 0 16 32 54 70 39 39 72 65 74 59 2 -6 -23 -38 -55 -70z m-94 -79 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-202 -203 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 295 l0 -115 66 0 c56 0 65 2 60 16 -3 9 -6 29 -6 45 0 24 -4 29 -25 29 -14 0 -25 -4 -25 -10 0 -5 7 -10 15 -10 9 0 15 -9 15 -25 0 -22 -4 -25 -35 -25 -39 0 -55 21 -35 45 10 12 10 18 0 30 -15 18 -5 35 21 35 27 0 24 18 -3 22 -15 2 -24 11 -26 26 -3 19 1 22 31 22 19 0 40 7 47 15 11 13 5 15 -44 15 l-56 0 0 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 396 c-11 -14 -8 -16 19 -16 26 0 31 -4 31 -25 0 -23 -3 -25 -50 -25 -27 0 -50 -4 -50 -10 0 -5 23 -10 50 -10 43 0 50 -3 50 -19 0 -11 -6 -22 -12 -25 -10 -5 -10 -7 0 -12 6 -3 12 -17 12 -30 0 -21 -5 -24 -35 -24 -31 0 -35 3 -35 25 0 16 6 25 15 25 8 0 15 5 15 10 0 6 -11 10 -25 10 -22 0 -25 -4 -25 -35 0 -19 -4 -35 -10 -35 -5 0 -10 -4 -10 -10 0 -6 30 -10 70 -10 l71 0 -3 113 -3 112 -31 3 c-19 2 -36 -3 -44 -12z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionplan);
export default __webpack_public_path__ + "static/media/actionplan.e3da6f4cfee3977543f9288b37ed17ae.svg";
export { ForwardRef as ReactComponent };